import { Box, Stack, SxProps, Theme } from '@mui/material';
import { DeviceRow } from '@src/types/devices/DeviceRow.types';
import { memo, ReactNode } from 'react';

interface DeviceMasterDetailProps {
  row: DeviceRow;
  unitControllerId: string;
  wrapperSx?: SxProps<Theme>;
  spacing?: number;
  children: (deviceId: string, unitControllerId: string) => ReactNode;
}

const DeviceMasterDetail = memo<DeviceMasterDetailProps>(
  ({ row, unitControllerId, wrapperSx, spacing = 2, children }) => {
    const deviceId = String(row.id);

    return (
      <Box sx={wrapperSx}>
        <Stack spacing={spacing}>{children(deviceId, unitControllerId)}</Stack>
      </Box>
    );
  },
  (prevProps, nextProps) =>
    prevProps.row.id === nextProps.row.id &&
    prevProps.unitControllerId === nextProps.unitControllerId,
);

DeviceMasterDetail.displayName = 'DeviceMasterDetail';

export default DeviceMasterDetail;
